import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc58fd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-wrap" }

import { reactive, ref, onMounted } from 'vue';
import { cloneDeep } from 'lodash';
import { useRoute } from 'vue-router';
import ProjectSearch from './components/projectSearch.vue';
import ProjectTable from './components/projectTable.vue';
import { getProjectList } from '@/api/project';
import EditProjectDrawer from './components/editProjectDrawer.vue';
import Pagination from '@/components/bussiness/Pagination/Index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

// 项目管理页面
const route = useRoute();
const paginationObj = reactive({
  pageNum: 1,
  pageSize: 10,
  totalCount: 0
});

let formData = {
  sid: route.query?.sid ? parseInt(route.query.sid as string, 10) : null,
  projectName: ''
};

const loading = ref(true);
const tableList = ref<Project.ProjectItem[]>([]);

const getList = async () => {
  const { pageNum, pageSize } = paginationObj;
  const query = {
    ...formData,
    page: {
      pageNum,
      pageSize
    }
  };
  try {
    loading.value = true;
    const res = await getProjectList(query);
    // const res = mockProject;
    const { code, data } = res || {};
    if (`${code}` === '0') {
      tableList.value = data.projects;
      paginationObj.totalCount = data.page.totalCount;
    }
  } finally {
    loading.value = false;
  }
};

const onSearch = (searchData: { projectName: string; sid: number | null }) => {
  paginationObj.pageNum = 1;
  paginationObj.pageSize = 10;
  formData = { ...searchData };
  getList();
};

const onReset = (searchData: { projectName: string; sid: number | null }) => {
  paginationObj.pageNum = 1;
  paginationObj.pageSize = 10;
  formData = { ...searchData };
  getList();
};

// 添加/编辑抽屉
const drawerType = ref('create');
const editProjectDrawerVisible = ref(false);
const projectInfo = ref<Project.ProjectItem>();

const onCreate = () => {
  projectInfo.value = undefined;
  drawerType.value = 'create';
  editProjectDrawerVisible.value = true;
};
const editRow = (row: Project.ProjectItem) => {
  drawerType.value = 'edit';
  projectInfo.value = cloneDeep(row);
  editProjectDrawerVisible.value = true;
};

onMounted(() => {
  getList();
});

return (_ctx: any,_cache: any) => {
  const _component_e_button = _resolveComponent("e-button")!
  const _component_e_block = _resolveComponent("e-block")!
  const _component_EContent = _resolveComponent("EContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_EContent, { block: true }, {
        header: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_e_block, {
              title: "项目管理",
              sider: false
            }, {
              "header-right": _withCtx(() => [
                _createVNode(_component_e_button, { onClick: onCreate }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加项目")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(ProjectSearch, {
              onOnSearch: onSearch,
              onOnReset: onReset
            })
          ])
        ]),
        main: _withCtx(() => [
          _createVNode(ProjectTable, {
            "table-list": tableList.value,
            loading: loading.value,
            onOnEdit: editRow,
            onUpdateTable: getList
          }, null, 8, ["table-list", "loading"]),
          _createVNode(Pagination, {
            pageNo: paginationObj.pageNum,
            "onUpdate:pageNo": _cache[0] || (_cache[0] = ($event: any) => ((paginationObj.pageNum) = $event)),
            pageSize: paginationObj.pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((paginationObj.pageSize) = $event)),
            total: paginationObj.totalCount,
            onPagination: getList
          }, null, 8, ["pageNo", "pageSize", "total"])
        ]),
        _: 1
      })
    ]),
    (editProjectDrawerVisible.value)
      ? (_openBlock(), _createBlock(EditProjectDrawer, {
          key: 0,
          drawerVisible: editProjectDrawerVisible.value,
          "onUpdate:drawerVisible": _cache[2] || (_cache[2] = ($event: any) => ((editProjectDrawerVisible).value = $event)),
          type: drawerType.value,
          "project-info": projectInfo.value,
          onOnSuccess: getList
        }, null, 8, ["drawerVisible", "type", "project-info"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})